import React, { useState } from "react";
import VideoPopup from "../../common/Modals/VideoPopup";

const ModificationDetails = () => {
  const [isVideoOpen,setIsVideoOpen] = useState(false);
  return (
    <>
      <div className="tp-service-page pt-140 pb-140">
        <div className="container">
          <div className="row pb-30">
            <div className="col-lg-6 mb-30">
              <div className="tp-sv-inner-img w-img">
                <img src="/assets/img/service/service-modern1.jpeg" alt="" />
              </div>
            </div>
            <div className="col-lg-6 mb-30">
              <div className="tp-sv-inner-img w-img">
                <img src="/assets/img/service/service-modern2.jpeg" alt="" />
              </div>
            </div>
          </div>
          <div className="row">
            <div className="col-lg-12">
              <div className="tp-sv__content">
                <h3 className="tp-sv__title">Elevator Modernization & Upgrades</h3>
                <p>
                Lumetiq Elevators Pvt Ltd specializes in elevator modification services to 
                  enhance the efficiency, safety, and aesthetics of your lifts. Our upgrade 
                  solutions improve performance while ensuring compliance with the latest 
                  industry standards.{" "}
                </p>

                <p>
                Whether you're looking to upgrade outdated control systems, improve ride 
                  quality, or enhance safety features, our team provides customized 
                  modification plans tailored to your specific requirements.
                </p>

                <h4 className="tp-sv__subtitle">
                Enhancing Performance & Safety
                </h4>
                <p>
                Our elevator modernization services include advanced control panel 
                  upgrades, energy-efficient motor replacements, and aesthetic improvements 
                  such as new cabin designs and LED lighting.
                </p>
                <p>
                We focus on delivering cost-effective solutions that reduce energy 
                  consumption, minimize downtime, and ensure smooth operation. Our experts 
                  assess your current system and recommend upgrades that align with 
                  your building's needs.
                </p>

                <p>
                Trust Lumetiq Elevators Pvt Ltd for reliable modification solutions that 
                  enhance both the functionality and appearance of your elevators.
                </p>

                <div className="tp-sv__video">
                  <div
                    className="tp_sv__video-bg"
                    // data-background="/assets/img/service/service-blog-bg.jpg"
                    style={{
                      backgroundImage: `url("/assets/img/service/service-blog-bg.jpg")`,
                    }}
                  >
                    {/* <div className="pt-180 pb-180 text-center p-relative">
                      <span>
                        <button
                          onClick={()=> setIsVideoOpen(true)}
                          className="sv-video sv-popup-video"
                        >
                          <i className="fas fa-play"></i>
                        </button>
                      </span>
                    </div> */}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* video modal start */}
      <VideoPopup
        isVideoOpen={isVideoOpen}
        setIsVideoOpen={setIsVideoOpen}
        videoId={"EW4ZYb3mCZk"}
      />
      {/* video modal end */}
    </>
  );
};

export default ModificationDetails;
